
import { SlotGameType1_2 } from "../SlotGameType1_2";
// import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
// import { ResourceManager } from "../../ResourceManager/ResourceManager";
// import {  FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
// import { SetStyles } from "../.././MyHelpers";
// import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";

// namespace SlotGames2
// {
	export class JuicyIce2 extends SlotGameType1_2
	{
	
	
	}
// }